const template = require('./content.html');

export default {
    template,
    transclude: true
};



// WEBPACK FOOTER //
// ./app/common/content/content.component.js